import { getCurrencySymbol } from "./utils";

export function formatPresetSublabel(
  type: "perSqm" | "perRoom" | "percent",
  val: number,
  currency: "EUR" | "USD" | "GBP",
): string {
  const rawCurrencySymbol = getCurrencySymbol(currency);
  if (type === "percent") return `${val}%`;
  if (type === "perSqm")
    return `${rawCurrencySymbol}${val.toLocaleString()}/sqm`;
  return `${rawCurrencySymbol}${val.toLocaleString()}/room`;
}

export function formatCurrency(
  value: number,
  currency: string = "EUR",
  locale: string = "en-GB",
): string {
  const finalLocale = currency === "USD" ? "en-US" : locale;

  return new Intl.NumberFormat(finalLocale, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
    currencyDisplay: "symbol",
  }).format(value);
}

export type Scale = "full" | "thousands" | "millions";
